import { createFileRoute } from "@tanstack/react-router"
import LinearProgress from "@mui/material/LinearProgress"
import { useTenant } from "@/helpers/firebaseGetMethods"
import CoreSettingsPage from "@/components/coreSettings/CoreSettingsPage"
import SettingsPage from "@/components/coreSettings/SettingsPage"

// The page grouped by source goes with the grouped navbar
// (backlog/settings-by-source.md, A1). A failed user read falls to the old
// page, which is where the firm switcher has always been.
function SettingsRoute() {
  const { data: tenantData, isPending } = useTenant()
  if (isPending) return <LinearProgress sx={{ mt: 4 }} />
  return tenantData?.featureFlags?.newNavigation === true ? <SettingsPage /> : <CoreSettingsPage />
}

// ?section= names the section to open (useSettingsSection).
const validateSearch = (search) =>
  typeof search.section === "string" ? { section: search.section } : {}

export const Route = createFileRoute("/core/settings")({ component: SettingsRoute, validateSearch })
